module.exports = __webpack_public_path__ + "static/media/polly.eb758a14.jpg";